import { faComment, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Flex, ResponsiveTable, Text } from '@modusign/design-system';
import moment from 'moment';

import Contact from '@app/features/addressBook/types/Contact';
import getFormattedSouthKoreaPhoneNumber from '@app/libs/inputFormat/getFormattedSouthKoreaPhoneNumber';

import { CONTACT_LIST_CREATED_AT_WIDTH, CONTACT_LIST_NAME_COLUMN_WIDTH } from '../ContactList';

interface ContactListItemProps extends Partial<Contact> {
  checked: boolean;
  onCheckClick: () => void;
  onClick: () => void;
}

function ContactListItem({
  checked,
  companyName,
  createdAt,
  departmentPosition,
  name,
  email,
  phoneNumber,
  onCheckClick,
  onClick,
}: ContactListItemProps) {
  return (
    <>
      <ResponsiveTable.TBodyRow
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          onClick();
        }}
      >
        <ResponsiveTable.TD
          display={['none', null, 'table-cell']}
          width="40px"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onCheckClick();
          }}
        >
          <Checkbox checked={checked} data-testid="contact-list-item-checkbox" />
        </ResponsiveTable.TD>
        <ResponsiveTable.TD>
          <Flex flexDirection="column" maxWidth={`${CONTACT_LIST_NAME_COLUMN_WIDTH - 25}px`}>
            <Text
              as="p"
              ellipsis
              fontSize="md"
              fontWeight="medium"
              mb={0}
              sx={{ overflowY: 'hidden' }}
            >
              {name}
            </Text>
            {companyName && (
              <Text
                as="p"
                color="textNeutralVeryLight"
                ellipsis
                fontSize="xs"
                mb={0}
                sx={{ overflowY: 'hidden' }}
              >
                {companyName}
              </Text>
            )}
            {departmentPosition && (
              <Text
                as="p"
                color="textNeutralVeryLight"
                ellipsis
                fontSize="xs"
                mb={0}
                sx={{ overflowY: 'hidden' }}
              >
                {departmentPosition}
              </Text>
            )}
          </Flex>
        </ResponsiveTable.TD>
        <ResponsiveTable.TD>
          <Flex flexDirection="column">
            {phoneNumber && (
              <Flex>
                <Text color="textNeutralLight" fontSize="md">
                  <FontAwesomeIcon icon={faComment} />
                </Text>
                <Text as="p" color="textNeutralLight" fontSize="md" ml={2}>
                  {getFormattedSouthKoreaPhoneNumber(phoneNumber)}
                </Text>
              </Flex>
            )}
            {email && (
              <Flex>
                <Text color="textNeutralLight" fontSize="md">
                  <FontAwesomeIcon icon={faEnvelope} />
                </Text>
                <Text as="p" color="textNeutralLight" fontSize="md" ml={2}>
                  {email}
                </Text>
              </Flex>
            )}
          </Flex>
        </ResponsiveTable.TD>
        <ResponsiveTable.TD
          display={['none', null, 'table-cell']}
          width={CONTACT_LIST_CREATED_AT_WIDTH}
        >
          <Text color="textNeutralVeryLight" fontSize="sm">
            {moment(createdAt).format('YYYY.MM.DD')}
          </Text>
        </ResponsiveTable.TD>
      </ResponsiveTable.TBodyRow>
    </>
  );
}

export default ContactListItem;
